interface CallToActionProps {
  children: React.ReactNode;
  bgColour?: string;
}

export default function CallToAction({
  children,
  bgColour,
}: CallToActionProps) {
  return (
    <section
      id="get-started-today"
      className={`relative overflow-hidden pt-20 pb-48 ${bgColour} px-10`}
    >
      <div className="max-w-7xl px-4 sm:px-6 lg:px-8 relative bg-light/20 py-20 mx-auto rounded-3xl">
        {children}
      </div>
    </section>
  );
}

CallToAction.defaultProps = {
  bgColour: "bg-dark",
};
